import React, { useState,
  //  useCallback
   } from 'react';
import { Grid } from '@mui/material';
import ReactTextareaAutocomplete from '@webscopeio/react-textarea-autocomplete';
import '@webscopeio/react-textarea-autocomplete/style.css';
import ReactHtmlParser from 'html-react-parser';

import {
  checkPrivileges,
  errorHandler,
  postionAttributes,
  // postionAttributesTypeComp,
} from '../../../Helpers';

import TextField from '../../../Components/common/TextField';
import { Button, Tooltip } from '../../../Components/common';
import Checkbox from '../../../Components/common/Checkbox';
import MenuItem from '../../../Components/common/MenuItem';
import SingleSelect from '../../../Components/common/SingleSelect';
import Autocomplete from '../../../Components/common/Autocomplete';
import { useDispatch, useSelector } from 'react-redux';
import instance from '../../../axios';




const att_valueType = [
  {
    Type: 'string'
  },
  { Type: 'number' },
  { Type: 'boolean' }
];

const ElogicForm = (props) => {
  const {
    translate,
    // type,
    // suggestions = [],
    isHaveAccess,
    isAddVisableBtn,
    isLoading,
    addButtonStatus,
    addComputedAttributes,
    themecolors,
    computedAttForm,
    // attributeHandle,
    C_Att_handleChange,
    id,
  } = props;
const devices=useSelector((state)=>state.devices3)
const dispatch=useDispatch()
  // const [computedAttForm, setComputedAttForm] = useState(externalForm);
  const [testOpen, setTestOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [testResult, setTestResult] = useState('');

  const canEditAttributes =
    checkPrivileges('attributeCreate') || checkPrivileges('attributeUpdate');
  const canAccess = checkPrivileges(isHaveAccess);

  // const attributeHandle = useCallback((name, value) => {
  //   setComputedAttForm((prev) => {
  //     // Special handling for nested attribute
  //     if (name === 'copyFromLast') {
  //       return {
  //         ...prev,
  //         attributes: { ...prev.attributes, copyFromLast: value },
  //       };
  //     }

  //     // Determine type dynamically
  //     const selectedType =
  //       postionAttributesTypeComp.find((m) => m.key === value)?.valueType ||
  //       prev.type ||
  //       'string';

  //     return { ...prev, [name]: value, type: selectedType };
  //   });
  // }, []);

  const handleRunTest = () => {
        let device =devices?.find(
      d => parseInt(d.id) === parseInt(props.id)
    );
    if (device && device.id) {
      setSelectedDevice({
        id: props.id,
        label: device.name,
        key: props.id,
        value: props.id
      });
    }
    setTestResult("")
    setTestOpen((prev) => !prev)
  };

  const handleSelectUnit = (e, device) => {
    setSelectedDevice({ ...device, value: device.id });
  };

  const executeTest = async () => {
    try {
      const body = { ...computedAttForm };
      delete body.check;

      const deviceId = selectedDevice?.id || id;

      const result = await instance({
        url: `/api/attributes/computed/test`,
        method: 'POST',
        params: { deviceId },
        data: body,
      });

      setTestResult(`Result: ${result}`);
    } catch (error) {
      errorHandler(error, dispatch, errorCallBack);
    }
  };
  const errorCallBack = (data) => {
    setTestResult('Result: ' + data?.message);
  };
  return (
    <>
      <div
        style={{
          padding: '1px 20px',
          height: '100%',
        }}
      >
        <h4>{translate('sharedComputedAttribute')}</h4>

        <Grid container>
              <Grid item xs={12}>
                <TextField
                  id='description'
                  label={props.translate('sharedDescription')}
                  type='text'
                  value={props.computedAttForm.description}
                  onChange={props.C_Att_handleChange('description')}
                  variant='outlined'
                  margin='dense'
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  suggestions={postionAttributes}
                  fieldName='attribute'
                  translate={props.translate}
                  label={props.translate('sharedAttribute')}
                  value={
                    props.computedAttForm.attribute
                      ? props.computedAttForm.attribute
                      : ''
                  }
                  handleChange={C_Att_handleChange}
                  canRemove={
                    checkPrivileges('attributeCreate') ||
                    checkPrivileges('attributeUpdate')
                  }
                  canAssign={
                    checkPrivileges('attributeCreate') ||
                    checkPrivileges('attributeUpdate')
                  }
                />
              </Grid>
              {props.type === 'units' ? (
                <Grid item xs={12} style={{ marginTop: 8 }}>
                  <Tooltip
                    classes={{
                      popper: 'menu-popper',
                      tooltip: 'menu-popper-tooltip'
                    }}
                    placement='bottom-start'
                    title={
                      <>
                        {props.translate('InputStartingWith')}
                        distance = speed*time.
                      </>
                    }
                  >
                    <Grid xs={12}>
                      <ReactTextareaAutocomplete
                        style={{ maxWidth: '100%' }}
                        onChange={props.C_Att_handleChange('expression')}
                        loadingComponent={() => <span>Loading</span>}
                        minChar={0}
                        rows={4}
                        placeholder={props.translate(
                          'sharedExpressionLabel'
                        )}
                        className='custom-theme-input theme-notchedOutline'
                        value={props.computedAttForm.expression}
                        trigger={{
                          ':': {
                            dataProvider: token => {
                              return props.suggestions
                                .filter(r => r.includes(token))
                                .map(row => ({
                                  name: row
                                }));
                            },
                            component: ({ entity: { name } }) => {
                              return <div>{`${name}`}</div>;
                            },
                            output: (item) => item.name
                          }
                        }}
                      />
                    </Grid>
                  </Tooltip>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <TextField
                    id='expression'
                    label={props.translate('sharedExpressionLabel')}
                    multiline
                    rowsMax='8'
                    rows='4'
                    value={props.computedAttForm.expression}
                    onChange={props.C_Att_handleChange('expression')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  id='type'
                  select
                  label={props.translate('sharedType')}
                  value={props.computedAttForm.type}
                  onChange={props?.C_Att_handleChange('type')}
                  margin='dense'
                  fullWidth
                >
                  {att_valueType.map(option => (
                    <MenuItem key={option.Type} value={option.Type}>
                      {props.translate(option.Type)}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} style={{ paddingTop: 5 }}>
                <Checkbox
                  canAssign
                  canRemove
                  translate={props.translate}
                  checked={props.computedAttForm?.attributes?.copyFromLast || false}
                  onChange={(e)=>props?. attributeHandle("copyFromLast",e.target.checked)}

                  
                  label={props.translate('copyFromLast')}
                />
              </Grid>
            </Grid>

        {/* Footer Buttons */}
   {!testOpen&&     <div style={{ textAlign: 'right', marginTop: 10 }}>
          <Button size="small" sx={{ mr: 2 }} onClick={handleRunTest}>
            {translate('runTest')}
          </Button>
          {canAccess && (
            <Button
              disabled={!isAddVisableBtn || isLoading}
              size="small"
              onClick={addComputedAttributes}
            >
              {isLoading ? 'Loading...' : translate(addButtonStatus || 'add')}
            </Button>
          )}
        </div>}
        {/* Test Section */}
      {testOpen && (
        <Grid container spacing={1} mt={1}>
        <h4>{translate('devices')}</h4>

          {/* Device Selector */}
          <Grid item sm={12} xs={12} sx={{marginBottom:"1.5rem"}}>
            <SingleSelect
              array={devices.map((d) => ({ ...d, key: d.id }))}
              selectName="unit"
              label={translate('pleaseSelectedUnit')}
              value={selectedDevice || { key: '', label: '', id: '' }}
              handleChange={handleSelectUnit}
              canRemove={canEditAttributes}
              canAssign={canEditAttributes}
            />
          </Grid>

          {/* Test Result */}
          {testResult && (
            <Grid item xs={12}>
              <div
                style={{
                  color: themecolors?.error,
                  fontWeight: 700,
                  fontStyle: 'italic',
                  marginTop: 4,
                }}
              >
                {ReactHtmlParser(testResult)}
              </div>
            </Grid>
          )}

          {/* Run Test Button */}
          <Grid item xs={12} display="flex" justifyContent="flex-end">
                 <Button size="small" sx={{ mr: 2 }} onClick={handleRunTest}>
            {translate('close Devices')}
          </Button>
            <Button
              size="small"
              // style={{
              //   background: themecolors?.backgroundColor,
              //   color: themecolors?.textColor,
              // }}
              variant="contained"
              color="secondary"
              disabled={!selectedDevice}
              onClick={executeTest}
            >
              {translate('runTest')}
            </Button>
          </Grid>
        </Grid>

      )}
      </div>

    </>
  );
};

export default ElogicForm;
